module.exports = __webpack_public_path__ + "static/media/Front-Of-Hand(R) v1.16775242.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Front-Of-Hand(R) v1.jpg
// module id = 408
// module chunks = 0